import axios from "axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { ServiceResponseI } from "../../interfaces";
import { AxiosError } from "axios";
import { reportDispatchApi } from "./axios";

const handleErr = (err: unknown): never => {
  const obj = (err as AxiosError).response;
  if (obj?.status === 401) LogoutSystem();
  throw new Error((obj?.data as Error)?.message ?? "Error desconocido");
};

export type SendReportDocumentType =
  | "invoice-sri"
  | "invoice-sri-xml"
  | "invoice"
  | "quotation";
export type SendReportModuleType =
  | "issued"
  | "received"
  | "sale"
  | "credit-note"
  | "quotation";

export interface SendReportPayloadI {
  document: SendReportDocumentType;
  module: SendReportModuleType;
  id: string;
  mails: string[];
  phones: string[];
}

export interface SendReportResultI {
  mailsSent: string[];
  mailsFailed: { mail: string; error: string }[];
  phonesSent: string[];
  phonesFailed: { phone: string; error: string }[];
}

export const sendReport = async (
  payload: SendReportPayloadI,
): Promise<ServiceResponseI<SendReportResultI>> => {
  try {
    const token = ValidateCurrentToken();
    if (!token) throw new Error("TOKEN INVALIDO");
    const { data } = await reportDispatchApi.post("/send", payload, {
      headers: { Authorization: token },
    });
    return data;
  } catch (err) {
    return handleErr(err);
  }
};
